import React, { useEffect, useRef, useState } from "react";
import { AiOutlineCloseCircle } from "react-icons/ai";
import SearchField from "../../commonComponent/SearchField";
import { useCareTeamContext } from "../../Context/CareTeamContext";
import { getDoctors } from "../../services/DoctorService";
import { getMyGroupList } from "../../services/GroupService";
import { isEmpty, showToastError, showToastSuccess } from "../../Utils/Helper";
import Select from "react-select";
import { getActiveProgram } from "../../services/ActivePrograms";
import {
  addCareTeam,
  getCareTeams,
  getCareTeamsforAdmin,
} from "../../services/CareTeam";
import { useAuth } from "../../Context/AuthContext";

const initialData = {
  teamName: "",
  description: "",
  teamMeambers: [],
  teamManager: "",
  groups: [],
  programs: [],
  status: true,
};

const CreateViewTeam = ({ modalOpen, setModalOpen, editData }) => {
  const { setAllTeams, allTeams, setGroupSignal, setProgramSignal, setProviderSignal } =
    useCareTeamContext();
  const [formData, setFormData] = useState(initialData);
  const [formValues, setFormValues] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [allDoctors, setAllDoctors] = useState();
  const [filterdata, setFilterData] = useState();
  const [showDropdown, setShowDropdown] = useState(false);
  const [groupList, setGroupList] = useState();
  const [programList, setProgramList] = useState();
  const [editStatus, setEditStatus] = useState(false);
  const [error, setError] = useState(false);
  const [teamId, setTeamId] = useState();
  const searchFieldRef = useRef();
  const popoverRef = useRef();
  const { isAdmin } = useAuth();

  const getAllCareTeamsNew = async () => {
    try {
      const response = isAdmin
        ? await getCareTeamsforAdmin()
        : await getCareTeams();
      if (response.status !== 200) {
        return;
      }
      setAllTeams(response?.data?.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (modalOpen) {
      getGroupLists();
      setSearchTerm("");
      getDoctorsList();
      getProgramLists();
      setFormData(initialData);
      setFormValues([]);
      setGroupSignal(false);
      setProgramSignal(false);
      setProviderSignal(false);

      // Set the initial width when the component mounts

      // Add a click event listener to close the popover when clicking outside of it
      document.addEventListener("click", handleDocumentClick);

      return () => {
        // Remove the event listener when the component unmounts
        document.removeEventListener("click", handleDocumentClick);
      };
    }
  }, [modalOpen]);


  useEffect(() => {

    const updateFormData = () => {
      const editedGroups = editData.groups.map((group) => ({
        label: group.groupName,
        value: group._id,
      }));
      const editedPrograms = editData.programs.map((program) => ({
        label: program.programName,
        value: program._id,
      }));
      setFormData({
        teamName: editData.teamName,
        description: editData.description,
        teamMeambers: editData.teamMeambers?.map((member => member._id)),
        teamManager: editData.teamManager,
        groups: editedGroups,
        programs: editedPrograms,
        status: editData.status,
      });
      setTeamId(editData._id);
      getDoctorsList(editData);
    };
    if (editData) {
      setEditStatus(true);
      updateFormData();
    }
  }, [editData]);

  // console.log("fromData ====>", formData);
  // console.log("fromValue ====>", formValues);

  const checkValidation = () => {
    let valid = false;

    if (isEmpty(formData?.teamName) && formData?.teamName === "") {
      setError(!valid);
      return valid;
    }
    if (isEmpty(formData?.description) && formData?.teamName === "") {
      setError(!valid);
      return valid;
    }
    if (isEmpty(formData?.teamManager) && formData?.teamName === "") {
      setError(!valid);
      return valid;
    }
    if (!formData?.teamMeambers?.length > 0) {
      setError(!valid);
      return valid;
    }
    // if (!formData?.groups?.length > 0) {
    //   setError(!valid);
    //   return valid;
    // }
    // if (!formData?.programs?.length > 0) {
    //   setError(!valid);
    //   return valid;
    // }
    valid = true;
    setError(false);
    return valid;
  };

  const handleItemClick = (doctor) => {
    setFormValues([...formValues, doctor ]);
    setShowDropdown(false);
    setFormData({
      ...formData,
      teamMeambers: [...formData.teamMeambers, doctor._id],
    });
  };


  const handleDocumentClick = (e) => {
    // Close the popover if the click is outside the popover and search field
    if (
      popoverRef.current &&
      !popoverRef.current.contains(e.target) &&
      searchFieldRef.current &&
      !searchFieldRef.current.contains(e.target)
    ) {
      setShowDropdown(false);
    }
  };

  useEffect(() => {
    if (searchTerm) {
      onMemberSearch(searchTerm);
    } // eslint-disable-next-line
  }, [searchTerm]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    let payload = {
      ...formData,
      groups: formData.groups.map((group) => group.value),
      programs: formData.programs.map((program) => program.value),
    };
    try {
      if (payload) {
        if (!checkValidation()) return;
        const response = await addCareTeam(payload, editStatus ? teamId : "");
        if (response.status === 200) {
          showToastSuccess(
            editStatus ? "Care team updated" : "Care team created"
          );
          setModalOpen(false);
          setEditStatus(false);
          getAllCareTeamsNew();
          setFormData(initialData);
          setFormValues([]);
          setSearchTerm("");
          setGroupSignal(true);
          setProgramSignal(true);
          setProviderSignal(true);
          setError(false);
        } else {
          showToastError(response.data);
          return;
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  // let addFormFields = () => {
  //   setFormValues([...formValues, { members: "" }]);
  // };

  let removeFormFields = (i, element) => {
    let newFormValues = [...formValues];
    newFormValues.splice(i, 1);
    setFormValues(newFormValues);
    setFormData({
      ...formData,
      teamMeambers: [...formData.teamMeambers].filter(
        (item) => item !== element._id
      ),
      teamManager:
        formData.teamManager === element._id ? "" : formData.teamManager,
    });
  };

  const getDoctorsList = async (data = null) => {
    try {
      const response = await getDoctors();
      if (response.status !== 200) {
        setAllDoctors([]);
        setFilterData([]);
        return;
      }
      let filteredRes = response?.data?.data?.filter(
        (item) => item.status !== "inactive" ?? false
      );
      setAllDoctors(filteredRes);
      setFilterData(filteredRes);
      if (data) {
        let editedData = response?.data?.data?.map(
          (item) => data.teamMeambers?.filter(member => member._id === item._id) ?? []
        );
        let doctor = JSON.parse(localStorage.getItem("authUser"));
        let includedDoctor = data.teamMeambers?.filter(member => member._id === doctor._id ? [...editedData,doctor] : [...editedData]);
        setFormValues([
          ...formValues,
          ...includedDoctor.map((doctor) => ( doctor )),
        ]);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const onMemberSearch = async (searchTerm) => {
    let searchWord = searchTerm;
    const result = allDoctors.filter((value) => {
      return (
        value?.full_name?.toLowerCase()?.includes(searchWord?.toLowerCase()) ??
        false
      );
    });

    if (searchWord === "") {
      setFilterData(allDoctors);
      // getGroupLists(searchWord);
    } else {
      setFilterData(result);
    }
  };

  const getGroupLists = async () => {
    try {
      const response = await getMyGroupList();

      if (response.status === 200) {
        let filteredRes = response?.data?.data?.filter(
          (item) => !item.isArchive ?? false
        );
        // if (data) {
        //   let editedData = response?.data?.data?.filter(
        //     (item) => data.teamMeambers.includes(item._id) ?? []
        //   );
        //   setFormValues([
        //     ...formValues,
        //     ...editedData.map((doctor) => ({ members: doctor })),
        //   ]);
        // }
        setGroupList(filteredRes);
        setTimeout(() => {}, 1000);
      } else {
        showToastError(response?.data || response.message);
        // setLoader(false);
      }
    } catch (error) {
      // setLoader(false);
      error?.data?.data &&
        showToastError(error?.data?.data || error.data?.message);
    }
  };
  const getProgramLists = async () => {
    try {
      const response = await getActiveProgram();

      if (response.status === 200) {
        let filteredRes = response?.data?.data?.filter(
          (item) => !item.isArchive ?? false
        );
        setProgramList(filteredRes);
        setTimeout(() => {}, 1000);
      } else {
        showToastError(response?.data || response.message);
        // setLoader(false);
      }
    } catch (error) {
      // setLoader(false);
      error?.data?.data &&
        showToastError(error?.data?.data || error.data?.message);
    }
  };

  const getNamesOptions = (
    list,
    labelName = "label",
    labelKey = "label",
    valueKey = "value"
  ) => {
    return (
      list?.map((item) => ({
        [labelKey]: item[labelName],
        [valueKey]: item._id,
      })) || []
    );
  };

  const renderDropdown = (
    label,
    stateKey,
    list,
    isMulti = false,
    labelName
  ) => {
    const assignedGroup = list?.filter((group) => {
      let isGroupAssigned = allTeams?.some((team) =>
        team[stateKey].some((item) => item._id === group._id)
      );
      return !isGroupAssigned;
    });
    return (
      <div className="member-select col-md-10">
        <Select
          menuPlacement="top"
          isMulti={isMulti}
          className=""
          onChange={(data) => {
            setFormData({ ...formData, [stateKey]: data.map((dt) => dt) });
            renderDropdown(label, stateKey, list, isMulti, labelName);
          }}
          value={formData[stateKey]}
          placeholder={`Assign ${label}`}
          options={getNamesOptions(assignedGroup, labelName).map(
            (option, index) => ({
              ...option,
              key: `${option.value}`,
            })
          )}
        />
      </div>
    );
  };

  const getMembersNames = () => {
    if (Array.isArray(formValues)) {
      const result = formValues?.map((item) => {
        return {
          label: item?.full_name,
          value: item?._id,
        };
      });
      return result || [];
    }
  };

  // const getGroupsNames = () => {
  //   const result = groupList?.map((item) => {
  //     return {
  //       label: item.groupName,
  //       value: item._id,
  //     };
  //   });
  //   return result || [];
  // };

  // const getProgramsNames = () => {
  //   const result = programList?.map((item) => {
  //     return {
  //       label: item.programName,
  //       value: item._id,
  //     };
  //   });
  //   return result || [];
  // };

  const renderMemberDropDown = () => {
    return (
      <div className="member-select col-md-10">
        <Select
          menuPlacement="top"
          className=""
          value={
            getMembersNames().filter((item) => {
              if (item.value === formData.teamManager) {
                return {
                  label: item?.label,
                  value: item?.value,
                };
              }
              return false;
            })[0]
          }
          onChange={(data) => {
            setFormData({ ...formData, teamManager: data ? data.value : "" });
          }}
          placeholder={"Assign Member Manager"}
          options={getMembersNames()}
          isClearable
        />
      </div>
    );
  };

  // const renderAddGroupDropDown = () => {
  //   return (
  //     <div className="member-select col-md-10">
  //       <Select
  //         menuPlacement="top"
  //         isMulti
  //         className=""
  //         onChange={(data) => {
  //           setFormData({ ...formData, groups: data.map((dt) => dt.value) });
  //         }}
  //         placeholder={"Assign Group"}
  //         options={getGroupsNames()}
  //       />
  //     </div>
  //   );
  // };

  // const renderAddProgramsDropDown = () => {
  //   return (
  //     <div className="member-select col-md-10">
  //       <Select
  //         menuPlacement="top"
  //         isMulti
  //         className=""
  //         onChange={(data) => {
  //           setFormData({ ...formData, programs: data.map((dt) => dt.value) });
  //         }}
  //         placeholder={"Assign Program"}
  //         options={getProgramsNames()}
  //       />
  //     </div>
  //   );
  // };
  return (
    <>
      <div
        class="modal fade"
        id="createviewteam"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
          <div class="modal-dialog viewteam_width8">
            <div class="modal-content">
              <div class="modal-header p-4">
                <h5 className="mb-0">Create view team</h5>
                <button
                  type="button"
                  class="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    setModalOpen(false);
                    setEditStatus(false);
                    setFormData(initialData);
                    setFormValues([]);
                    setGroupSignal(true);
                    setProgramSignal(true);
                    setProviderSignal(true);
                    setError(false);
                  }}
                ></button>
              </div>
              <div class="modal-body pb-4 px-4">
                <form>
                  <div className="row">
                    <div className="col-md-6">
                      <label
                        className="form-label  label-font fw-bold "
                        htmlFor="Team Name"
                      >
                        Team Name
                      </label>
                      <input
                        className="form-control description_inputf mb-3 mt-2"
                        placeholder="e.g. Diabetes management team"
                        value={formData.teamName}
                        onChange={(e) =>
                          setFormData({ ...formData, teamName: e.target.value })
                        }
                      />
                      {error && formData.teamName === "" ? (
                        <p className="text-danger resFont">
                          Please add team name
                        </p>
                      ) : null}

                      <label
                        className="form-label  label-font fw-bold "
                        htmlFor="Description"
                      >
                        Description
                      </label>
                      <textarea
                        rows="9"
                        type="text"
                        className="description_inputf description_descpf mt-2"
                        placeholder="Write a short description here"
                        value={formData.description}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            description: e.target.value,
                          })
                        }
                      />
                      {error && formData.description === "" ? (
                        <p className="text-danger resFont">
                          Please add team description
                        </p>
                      ) : null}
                    </div>

                    <div className="col-md-6">
                      <div
                        className="col-md-10 search-field"
                        ref={searchFieldRef}
                      >
                        <label
                          className="form-label ms-2 mb-4 label-font fw-bold "
                          htmlFor="Team Name"
                        >
                          Add a list of care team members
                        </label>
                        <SearchField
                          value={searchTerm}
                          onChange={(e) => setSearchTerm(e.target.value)}
                          onClick={() => setShowDropdown(true)}
                        />
                        {error && !formData.teamMeambers.length > 0 ? (
                          <p className="text-danger resFont">
                            Please add team members
                          </p>
                        ) : null}
                        {showDropdown && (
                          <div className="custom-popover Dash" ref={popoverRef}>
                            <div className="custom-popover-content w-100 ">
                              {filterdata
                                ?.filter((doctor) =>
                                  doctor?.full_name
                                    .toLowerCase()
                                    .includes(searchTerm.toLowerCase())
                                )
                                .map((doctor, index) => (
                                  <div
                                    key={index}
                                    className="custom-popover-item"
                                    onClick={() => handleItemClick(doctor)}
                                  >
                                    {doctor.full_name}
                                  </div>
                                ))}
                            </div>
                          </div>
                        )}
                      </div>
                      <div
                        className="overflow-y-scroll Dash overflow-x-hidden "
                        style={{ maxHeight: "280px" }}
                      >
                        {formValues?.map((element, index) => (
                          <div className="row mt-2" key={index}>
                            <div className="col-md-10">
                              <input
                                className="form-control description_inputf mb-2 mx-2"
                                type="members"
                                id="members"
                                name="members"
                                placeholder="e.g. Nutritionist"
                                value={element?.full_name}
                                readOnly
                              />
                            </div>

                            <div className="col-md-2 d-flex align-items-center">
                              {index >= 0 ? (
                                <button
                                  type="button"
                                  title="Remove"
                                  className="btn btn-outline-danger px-2"
                                  onClick={() =>
                                    removeFormFields(index, element)
                                  }
                                >
                                  <AiOutlineCloseCircle
                                    style={{ marginTop: "-4px" }}
                                    size="22px"
                                  />
                                </button>
                              ) : null}
                            </div>
                          </div>
                        ))}
                      </div>
                      {/* <Button
                  type={"button"}
                  text={
                    <>
                      <AiOutlinePlusCircle size={22} stroke="white" />
                      <span>Add More Provider</span>
                    </>
                  }
                  style={{ fontSize: "16px" }}
                  onClick={() => addFormFields()}
                  className="description_btnsave gap-1 d-flex justify-content-between align-items-center fw-normal "
                /> */}
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-11 d-flex align-items-center ">
                      <label
                        style={{ marginBottom: "35px" }}
                        className="form-label col-md-2 label-font fw-bold "
                        htmlFor="Assign Team Manager"
                      >
                        Assign Team Manager:
                      </label>
                      {renderMemberDropDown()}
                    </div>
                    {error && formData.teamManager === "" ? (
                      <p className="text-danger resFont">
                        Please add team manager
                      </p>
                    ) : null}
                    <div className="col-md-11 d-flex align-items-center ">
                      <label
                        style={{ marginBottom: "35px" }}
                        className="form-label col-md-2  label-font fw-bold "
                        htmlFor="Assign to Group"
                      >
                        Assign to Group(s):
                      </label>
                      {renderDropdown(
                        "Group",
                        "groups",
                        groupList,
                        true,
                        "groupName"
                      )}
                    </div>
                    {/* {error && !formData.groups.length > 0 ? (
                      <p className="text-danger resFont">
                        Please add team groups
                      </p>
                    ) : null} */}
                    <div className="col-md-11 d-flex align-items-center ">
                      <label
                        style={{ marginBottom: "35px" }}
                        className="form-label col-md-2  label-font fw-bold "
                        htmlFor="Assign to Program"
                      >
                        Assign to Program(s):
                      </label>
                      {renderDropdown(
                        "Program",
                        "programs",
                        programList,
                        true,
                        "programName"
                      )}
                    </div>
                    {/* {error && !formData.programs.length > 0 ? (
                      <p className="text-danger resFont">
                        Please add team programs
                      </p>
                    ) : null} */}
                  </div>

                  <hr />
                  <div className="d-flex justify-content-between mt-1">
                    <button
                      type="button"
                      className="btn btn-outline-secondary px-4"
                      data-bs-dismiss="modal"
                      onClick={() => {
                        setModalOpen(false);
                        setFormData(initialData);
                        setFormValues([]);
                        setEditStatus(false);
                        getAllCareTeamsNew();
                        setGroupSignal(true);
                        setProgramSignal(true);
                        setProviderSignal(true);
                        setError(false);
                      }}
                    >
                      Cancel
                    </button>
                    <button
                      className="btn btn-primary btn-custom"
                      type="submit"
                      data-bs-dismiss="modal"
                      aria-label="Close"
                      onClick={(e) => {
                        handleSubmit(e);
                      }}
                    >
                      {editStatus ? "Update Team" : "Create Team"}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
      </div>
    </>
  );
};

export default CreateViewTeam;
